import React, { useEffect } from "react";
import AppHeader from "../components/AppHeader";
import BottomNav from "../components/BottomNav";
import DesktopSidebar from "../components/DesktopSidebar";

export default function MainLayout({ title, subtitle, actions, children, showBackButton = true, user, onLogout, hideBottomNav = false }) {
  useEffect(() => {
    document.body.setAttribute('data-has-sidebar', 'true');
    return () => document.body.removeAttribute('data-has-sidebar');
  }, []);
  return (
    <div className="app-shell">
      <DesktopSidebar user={user} />
      {showBackButton && (
        <AppHeader showBackButton={showBackButton} user={user} onLogout={onLogout} />
      )}
      <div className="app-container" style={{ paddingBottom: hideBottomNav ? undefined : 80 }}>
        {(title || subtitle || actions) && (
          <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              {title ? <h1 className="section-title">{title}</h1> : null}
              {subtitle ? <p className="section-subtitle mt-2">{subtitle}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
          </div>
        )}

        {children}
      </div>
      {!hideBottomNav && <BottomNav />}
    </div>
  );
}
